import { render, staticRenderFns } from "./PendingFeesAfterAdmissionPrint.vue?vue&type=template&id=65f5cade&scoped=true&"
import script from "./PendingFeesAfterAdmissionPrint.vue?vue&type=script&lang=js&"
export * from "./PendingFeesAfterAdmissionPrint.vue?vue&type=script&lang=js&"
import style0 from "./PendingFeesAfterAdmissionPrint.vue?vue&type=style&index=0&id=65f5cade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5cade",
  null
  
)

export default component.exports